import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants from '../../utils/routeParamConstants';
import audio from '../../utils/audio';
import { getText, TEXT_KEY } from '../../utils/localization';
var LinkAccount = /*#__PURE__*/function (_Component) {
  function LinkAccount() {
    var _this;
    _classCallCheck(this, LinkAccount);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LinkAccount, [].concat(args));
    _this.linkedAccount = function () {
      audio.onClick();
      var asset = _this.props.assetsUrls.ImagesCdnBaseUrl + '/' + _this.props.cardLinkPopupImage;
      var linkAccountDetails = {
        linkAccountTitle: getText(TEXT_KEY.LINK_ACCOUNT_TITLE),
        buttonLabel: getText(TEXT_KEY.LINK_ACCOUNT_BUTTON),
        icon: _this.props.cardLinkPopupImage && asset,
        description: Object.values(getText(TEXT_KEY.LINK_ACCOUNT_DESCRIPTION_ITEMS))
      };
      return linkAccountDetails;
    };
    _this.handleLinkAccountForm = function () {
      return QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.LinkAccountForm));
    };
    return _this;
  }
  _inherits(LinkAccount, _Component);
  return _createClass(LinkAccount, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_RC_PROFILE_LINK_BENEFITS, undefined));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        memberLevel = _this$props.memberLevel,
        isAccountLinked = _this$props.isAccountLinked;
      var hideLinkButton = QueryParamsProxy.findParam(routeParamConstants.PARAM_RC_PROFILE_LINK_BENEFITS) === true;
      return this.props.render({
        memberLevel: memberLevel,
        isAccountLinked: isAccountLinked,
        linkAccount: this.linkedAccount(),
        handleLinkAccountForm: this.handleLinkAccountForm,
        linkedLoyaltyCardBonus: this.props.linkedLoyaltyCardBonus,
        hideLinkButton: hideLinkButton
      });
    }
  }]);
}(Component);
export { LinkAccount as default };